import { render } from "./TeamsModalCreate.pug?vue&type=template&id=1e59b338&lang=pug"
import script from "./TeamsModalCreate.js?vue&type=script&lang=js"
export * from "./TeamsModalCreate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__